import { memo } from 'react';
import styles from './Index.module.scss';

export const TopHeadline = memo(() => {
  return (
    <section className={styles.newsContainer}>
      <h3 className={styles.newsHeading}>Join American Republic Insurance Services&reg; today!</h3>
    </section>
  );
});
